module.exports = __webpack_public_path__ + "static/media/logo-blue.5183099b.svg";